import React from 'react';
import Account from '@material-ui/icons/AccountCircleOutlined';
import AssignmentInd from '@material-ui/icons/AssignmentIndOutlined';
import Person from '@material-ui/icons/PersonOutlined';
import VerticalAlignBottom from '@material-ui/icons/VerticalAlignBottom';
import Visibility from '@material-ui/icons/Visibility';
import Edit from '@material-ui/icons/Edit';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import AddUserCard from 'views/Users/UsersList/subcomponents/AddUserCard';
import GridContainer from 'components/Grid/GridContainer';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/usersStyle';
import makeStyles from '@material-ui/core/styles/makeStyles';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IUserInfoDialogProps {
	isDialogOpen: boolean;
	hideDialog: () => void;
}

const UserInfoDialog = ({ hideDialog, isDialogOpen }: IUserInfoDialogProps) => {
	const classes = useStyles();
	return (
		<CustomDialog
			isOpen={isDialogOpen}
			width={1024}
			dialogBody={
				<div className={classes.userInfoDialogWrapper}>
					<GridContainer justify="flex-start">
						<AddUserCard
							icon={<Account />}
							description={translate('end.user.description')}
							title={translate('numbers.user.ENDUSER')}
							listTitle={translate('end.user.no.access')}
							className={classes.addUserInfoCard}
						/>
						<AddUserCard
							icon={<AssignmentInd />}
							description={translate('manager.description')}
							title={translate('numbers.user.MANAGER')}
							listTitle={translate('manager.can')}
							listItems={[
								{
									icon: <Visibility />,
									text: translate('view.data'),
								},
								{
									icon: <VerticalAlignBottom />,
									text: translate('download.data'),
								},
							]}
							className={classes.addUserInfoCard}
						/>
						<AddUserCard
							icon={<Person />}
							description={translate('admin.description')}
							title={translate('numbers.user.ADMIN')}
							listTitle={translate('admin.can')}
							listItems={[
								{
									icon: <Visibility />,
									text: translate('view.data'),
								},
								{
									icon: <VerticalAlignBottom />,
									text: translate('download.data'),
								},
								{
									icon: <Edit />,
									text: translate('edit.data'),
								},
								{
									icon: <Edit />,
									text: translate('create.users'),
								},
							]}
							className={classes.addUserInfoCard}
						/>
					</GridContainer>
				</div>
			}
			hideDialog={hideDialog}
		/>
	);
};

export default UserInfoDialog;
